var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"san-button  ",staticStyle:{"color":"#de1e23"},style:({ marginRight: _vm.marginRight + 'px' }),on:{"click":_vm.clickHandle}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }